import { getJsonOrError } from '../../utils/fetch'
import { queryString } from '../../utils/window'
import { getApiServicesEndpoints } from '../../application/pageDataObject'
import { getCountryCode } from '../../providers/geolocationProvider'
import { getSite } from '../../application/pageDataObject'

const getDate = localTime => {
  const date = queryString.localTime
    ? new Date(queryString.localTime)
    : new Date(localTime.getTime() - localTime.getTimezoneOffset() * 60000)
  date.setSeconds(0, 0)
  return date
}

const getCampaignsFromCampaignManagerService = async (site, country, localTime) => {
  const result = await getJsonOrError(
    `${getApiServicesEndpoints().campaigns}?site=${site}&country=${country}&localTime=${getDate(
      localTime
    ).toJSON()}`
  )
  return result.data
}

let campaignsPromise = null

export const getCampaignsFromCampaignManager = async () => {
  const countryCode = await getCountryCode()
  if (!campaignsPromise) {
    campaignsPromise = getCampaignsFromCampaignManagerService(getSite(), countryCode, new Date())
  }

  return await campaignsPromise
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/campaigns/campaignManagerProvider.js